import React, { Fragment, useEffect, useState, useRef } from "react";
import { getSystemDay } from "functions/functions";
import { getEventosCalendarioParis } from "services/getEventosCalendario";
import { getFechasParis } from "../../../services/getFechasCalendario.js";
import ListaEventos from "../listaEventos/listaEventos.js";
import Card from "../card/card.js";
import Loading from "components/loading/loading";
import SinResultados from "components/calendarios/calendarioGangwon/sinResultados/sinResultados";
import "./listado.sass";
import mascota from 'assets/mascota-parisR.png';


export default function ListadoEnvivo({ seccion, numCards, verListado, targetB }) {
    const [dataEventos, setDataEventos] = useState([]);
    const [dataFiltradaEnVivo, setDataFiltradaEnVivo] = useState([]);
    const [error, setError] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const [dataFechas, setDataFechas] = useState(false);
    const [fechaParaFiltrar, setFechaParaFiltrar] = useState();

    const incrementarFecha = (fecha) => {
        // Crear un objeto Date a partir de la fecha de entrada
        const date = new Date(fecha);

        // Incrementar la fecha en un día
        date.setDate(date.getDate() + 1);

        // Obtener el año, mes y día de la fecha incrementada
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mes de 0 a 11, se suma 1
        const day = date.getDate().toString().padStart(2, '0'); // Día del mes

        // Formatear la fecha en el formato 'YYYY-MM-DD'
        const fechaFormateada = `${year}-${month}-${day}`;

        // Devolver la fecha incrementada
        return fechaFormateada;
    };

    useEffect(() => {
        getFechasParis()
            .then((data) => {
                setDataFechas(data);
            })
            .catch((error) => {
                console.error("Error al obtener las fechas:", error);
            });
    }, []);

    // verificacion para obtener la fecha que debe estar por defecto en el select de fecha
    useEffect(() => {
        if (dataFechas) {
            let fechaActual = getSystemDay(); //"2024-07-28"; //getSystemDay();
            const firstDate = dataFechas[0]?.value;
            const lastDate = dataFechas[dataFechas.length - 1]?.value;

            // si la fecha actual es diferente a la fecha inicial - ASIGNA DIA 0
            if (fechaActual <= firstDate) {
                setFechaParaFiltrar(firstDate);
            }
            // si la fecha actual es MAYOR o IGUAL a la fecha fin - ASIGNA ULTIMO DIA
            else if (fechaActual >= lastDate) {
                setFechaParaFiltrar(lastDate);
            }
            // si la fecha actual es IGUAL a alguna de las fechas - ASIGNA LA FECHA QUE COINCIDE
            else if (dataFechas.some((item) => item.value === fechaActual)) {
                // Asigna el valor de fechaActual a setNuevo
                setFechaParaFiltrar(fechaActual);
            }
            // si no coincide con ninguna opción, asigna la fecha de inicio por defecto
            else {
                setFechaParaFiltrar(firstDate);
            }
        }
    }, [dataFechas]);


    //solicitud para traer el listado de eventos
    const getEventos = async (fecha) => {
        try {
            const eventos = await getEventosCalendarioParis(fecha, seccion);
            let dia = fecha.replace(/-/g, "");


            if (eventos && eventos.data && eventos.statusCode === 200) {
                let transmissions = eventos.data.elems[dia].sort(
                    (a, b) =>
                        new Date(a.session_start_time_utc) - new Date(b.session_start_time_utc) ||
                        new Date(a.session_end_time_utc) - new Date(b.session_end_time_utc)
                );

                if (transmissions.length > 0) {
                    setDataEventos(transmissions);
                }
            } else if (eventos && eventos.statusCode === 404) {
                setError(true);
                setDataEventos([]);
            }
        } catch (e) {
            setError(true);
        } finally {
            setShowLoading(false);
            setError(false);
        }
    };


    const handleNoTransmissions = () => {
        const ultimaFecha = dataFechas[dataFechas.length - 1]?.value;
        const horaUsuario = new Date();
        const nuevaFecha = incrementarFecha(horaUsuario);
        const ultimaFechaDate = new Date(ultimaFecha);
        const nuevaFechaDate = new Date(nuevaFecha);

        if (nuevaFechaDate <= ultimaFechaDate) {
            setFechaParaFiltrar(nuevaFecha);
        } else {
            setDataFiltradaEnVivo(dataEventos);
        }
    };


    // peticion al servicio para obtener los eventos del calendario
    useEffect(() => {
        if (fechaParaFiltrar) {
            setShowLoading(true);
            getEventos(fechaParaFiltrar);

            // intervalo para ejecutar la función cada 15 minutos
            const intervalId = setInterval(() => {
                getEventos(fechaParaFiltrar);
            }, 900000);

            // eliminarel intervalo cuando el componente se desmonte o cambie la variable seccion
            return () => {
                clearInterval(intervalId);
            };

        }
    }, [fechaParaFiltrar])


    // realiza el filtrado de la fecha UTC para los partidos que estan en vivo
    useEffect(() => {
        const horaUsuario = new Date(); //"2024-07-28T01:05:00Z"; // new Date();

        if (dataEventos && dataEventos.length > 0) {
            const transmisionesEnVivo = dataEventos.filter((item) => {
                const itemEndDate = new Date(item.session_end_time_utc);
                return itemEndDate >= horaUsuario;
            });

            if (transmisionesEnVivo.length > 0) {
                setDataFiltradaEnVivo(transmisionesEnVivo);
            } else if (!transmisionesEnVivo || transmisionesEnVivo?.length === 0) {
                handleNoTransmissions();
            }
        }
    }, [dataEventos]); // El efecto se ejecuta cada vez que `dataEventos` cambia.

    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const envivoRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (envivoRef.current) {
            resizeObserver.observe(envivoRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [envivoRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------


    return (
        <div ref={envivoRef}>
            {/* seccion loading */}
            {showLoading && (<Loading />)}

            {/* seccion sin resultados  */}
            {(!showLoading && !error && dataEventos && dataEventos.length === 0) && <SinResultados componenteActual={seccion} />}

            {/* seccion con resultados de busqueda del dia */}
            {!showLoading && dataEventos && dataEventos.length !== 0 &&
                <>
                    <div className="envivo-component-listado colorL1">
                        <div className={Number(numCards) === 3 ? "container-general-listadoSuperior gridImpar gridImpar3" :
                            Number(numCards) === 6 ? "container-general-listadoSuperior gridImpar gridImpar6" :
                                (Number(numCards) === 4 || Number(numCards) === 8) && "container-general-listadoSuperior gridPar"
                        }>
                            {dataFiltradaEnVivo && dataFiltradaEnVivo.length !== 0 && dataFiltradaEnVivo.map((item, indice) =>
                                ((numCards && (indice + 1 <= numCards))) &&
                                <Fragment key={item._id}>
                                    <Card imagen={item.image} disciplina={item.discipline} titulo={String(item.session_title).length === 0 ? item.session_title_editorial : item.session_title} horaInicio={item.session_start_time_utc} horaFin={item.session_end_time_utc} enlace={item.url} tipo="imagen" targetB={targetB} estaEnvivo={item?.is_live}/>
                                </Fragment>
                            )}
                        </div>
                    </div>


                    {verListado === 'true' && dataFiltradaEnVivo && dataFiltradaEnVivo.length !== 0 && (dataFiltradaEnVivo.length - numCards) >= 1 &&
                        <div className="envivo-component-listado colorL2">
                            <div className="container-general-listaImagen">

                            {/* <div className={(dataFiltradaEnVivo.length - numCards) >= 35 ? "container-general-envivo-img liMas20" : (dataFiltradaEnVivo.length - numCards) <= 19 ? "container-general-envivo-img liMenos20" : "container-general-envivo-img liIntermedio"}> */}
                                <div className={(dataFiltradaEnVivo.length - numCards) === 1 ? "container-general-envivo-img liuno" : "container-general-envivo-img liMenos20"}>
                                    <div className="envivo-img-title">
                                        <div className="title-img"><h2 className="">MÁS EVENTOS</h2></div>
                                        {(dataFiltradaEnVivo.length - numCards) > 4 && <div className="mascota"><img className="" src={mascota} alt="mascota-paris"></img></div>}
                                    </div>
                                </div>

                                <div className={(dataFiltradaEnVivo.length - numCards) === 1 ? "container-general-envivo-lista liuno" : "container-general-envivo-lista"}>
                                    <ListaEventos dataFiltradaEnVivo={dataFiltradaEnVivo} numCards={numCards} targetB={targetB}/>
                                </div>
                            </div>
                        </div>
                    }
                </>
            }
        </div>
    )
}